import React, { useContext, useState } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../GlobalStates/ContextoGlobal'
import BackEndAPI from '../Services/BackEndAPI'
import { Button, Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close'
import InputText from '../DevComponents/InputText'
import SelectMultiplo from '../DevComponents/SelectMultiplo'
import ExibirJSONDev from '../DevComponents/ExibirJSONDev'
import { clsUtils } from 'zlib-utils'
import ClsValidacao from '../Utils/ClsValidacao'
import { dashAgendamentoInputInterface, relDashDesempenhoInterface } from '../ImportBackend/Interfaces/DashBoardsInterfaces'
import { DateTime } from 'luxon'
import ClsExportDataTableCSV from '../Utils/ClsExportDataTableCSV'
import DataTable, { DataTableCabecalhoInterface } from '../DevComponents/DataTable'
import ClsFormatacao from '../Utils/ClsFormatacao'
import Condicional from '../Layout/Condicional'

export default function DashDesempenho() {

  const clsFormatos: ClsFormatacao = new ClsFormatacao()

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'descricaoClinica',
      cabecalho: 'Clínica',
      alinhamento: 'left'
    },
    {
      campo: 'qtdAgendamentos',
      cabecalho: 'Agendamentos',
      alinhamento: 'right'
    },
    {
      campo: 'qtdNaoComparecimentos',
      cabecalho: 'Ausências',
      alinhamento: 'right'
    },
    {
      campo: 'perNaoComparecimentos',
      cabecalho: '%',
      alinhamento: 'right',
      format: (v) => clsFormatos.currency(v)
    },

    {
      campo: 'qtdComparecimentos',
      cabecalho: 'Comparecimentos',
      alinhamento: 'right'
    },
    {
      campo: 'perComparecimentos',
      cabecalho: '%',
      alinhamento: 'right',
      format: (v) => clsFormatos.currency(v)
    },
    {
      campo: 'qtdPagamentoDentroDoMes',
      cabecalho: 'Pagamentos Dentro do Mês',
      alinhamento: 'right'
    },
    {
      campo: 'perPgtoComparecimento',
      cabecalho: '% Pagamentos / Comparecimentos',
      alinhamento: 'right',
      format: (v) => clsFormatos.currency(v)
    },
    {
      campo: 'vrFaturamentoMensal',
      cabecalho: 'Faturamento Mensal',
      alinhamento: 'right',
      format: (v) => clsFormatos.currency(v)
    },
    {
      campo: 'ticketMedioMensal',
      cabecalho: 'Ticket Médio Mensal',
      alinhamento: 'right',
      format: (v) => clsFormatos.currency(v)
    },
    {
      campo: 'qtdFaturamentoGeral',
      cabecalho: 'Quantidade de Faturamento Geral',
      alinhamento: 'right'
    },
    {
      campo: 'vrFaturamentoGeral',
      cabecalho: 'Faturamento Geral',
      alinhamento: 'right',
      format: (v) => clsFormatos.currency(v)
    },
    {
      campo: 'ticketMedioGeral',
      cabecalho: 'Ticket Médio Geral',
      alinhamento: 'right',
      format: (v) => clsFormatos.currency(v)
    }
  ]

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface

  const abortController: AbortController = new AbortController()

  const navigate = useNavigate()

  const clsApi = new BackEndAPI()

  const ResetPesquisa: dashAgendamentoInputInterface = {
    rsUsuarios: [],
    rsUnidadesOrganizacionais: [],
    anoMesInicio: DateTime.now().toFormat('MM/yyyy'),
    anoMesTermino: DateTime.now().toFormat('MM/yyyy'),
    rsClinicas: []
  }

  const [rsRelDesempenho, setRsRelDesempenho] = useState<Array<relDashDesempenhoInterface>>([])

  const [rsPesquisa, setRsPesquisa] = useState<dashAgendamentoInputInterface>(ResetPesquisa)

  const [erros, setErros] = useState<Record<string, string>>({})

  const btFechar = () => {
    navigate('/')
  }

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    if (rsPesquisa.anoMesInicio.length > 0 && rsPesquisa.anoMesTermino.length > 0) {

      if (rsPesquisa.anoMesInicio.length !== 7) {
        erros.inicio = 'Data inicial inválida'
        retorno = false
      }

      if (rsPesquisa.anoMesTermino.length !== 7) {
        erros.termino = 'Data final inválida'
        retorno = false
      }

      if (retorno) {

        const [mesInicio, anoInicio] = rsPesquisa.anoMesInicio.split('/');
        const [mesTermino, anoTermino] = rsPesquisa.anoMesTermino.split('/');

        const rsValidarData = { inicio: `${anoInicio}-${mesInicio}-01`, termino: `${anoTermino}-${mesTermino}-01` }

        let clsValidacao = new ClsValidacao()

        retorno = clsValidacao.eData('inicio', rsValidarData, erros, retorno, true)
        retorno = clsValidacao.eData('termino', rsValidarData, erros, retorno, true)

        if (retorno && rsValidarData.inicio > rsValidarData.termino) {
          erros.termino = 'Data final não pode ser menor que a data inicial'
          retorno = false
        }

      }

    }

    setErros(erros)

    return retorno

  }

  const btPesquisar = () => {

    if (validarDados()) {

      const [mesInicio, anoInicio] = rsPesquisa.anoMesInicio.split('/');
      const [mesTermino, anoTermino] = rsPesquisa.anoMesTermino.split('/');

      const query: string = `
        dashDesempenho (pesquisa: ${clsUtils.ConverterEmGql({
            anoMesInicio: `${anoInicio}${mesInicio}`,
            anoMesTermino: `${anoTermino}${mesTermino}`,
            rsClinicas: rsPesquisa.rsClinicas.map((v: any) => v.idClinica),
            rsUsuarios: rsPesquisa.rsUsuarios.map((v: any) => v.idUsuario),
            rsUnidadesOrganizacionais: rsPesquisa.rsUnidadesOrganizacionais.map((v: any) => v.idUnidadeOrganizacional)
          })})
      `

      clsApi.query<Array<relDashDesempenhoInterface>>(query, 'dashDesempenho', 'Gerando Relatório de Desempenho...', contexto, abortController).then((rs) => {

        setRsRelDesempenho(rs)

      })

      return () => {

        abortController.abort()

      }

    }

  }

  const btDownload = () => {
    const clsExportaCSV: ClsExportDataTableCSV = new ClsExportDataTableCSV()

    clsExportaCSV.exportCSV('Agendamentos', rsRelDesempenho, Cabecalho)
  }

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Desempenho das Clínicas
                <Typography variant="body2" gutterBottom>
                </Typography>
              </Typography>

              <IconButton onClick={() => btFechar()}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12} md={8} >

              <SelectMultiplo
                fieldsRetornoObjeto={['idClinica', 'descricao']}
                dados={rsPesquisa}
                field='rsClinicas'
                fieldIdSelect='idClinica'
                fieldSelect='descricao'
                label='Clínicas'
                setState={setRsPesquisa}
                pesquisaInicial={{
                  mensagem: 'Pesquisando Clínicas',
                  tipo: 'Query',
                  pesquisa: 'getClinicas {idClinica, descricao}',
                  objRetorno: 'getClinicas'
                }
                }
              />

            </Grid>

            <Grid item xs={12} md={2} sx={{ pl: { md: 1 } }}>

              <InputText
                dados={rsPesquisa}
                field='anoMesInicio'
                label='Início'
                mask='00/0000'
                setState={setRsPesquisa}
                erros={erros}
              />

            </Grid>

            <Grid item xs={12} md={2} sx={{ pl: { md: 1 } }}>

              <InputText
                dados={rsPesquisa}
                field='anoMesTermino'
                label='Término'
                mask='00/0000'
                setState={setRsPesquisa}
                erros={erros}
              />

            </Grid>

            <Grid item xs={12} md={6}>

              <SelectMultiplo
                fieldsRetornoObjeto={['idUnidadeOrganizacional', 'descricao']}
                dados={rsPesquisa}
                field='rsUnidadesOrganizacionais'
                fieldIdSelect='idUnidadeOrganizacional'
                fieldSelect='descricao'
                label='Unidade Organizacional'
                setState={setRsPesquisa}
                pesquisaInicial={{
                  mensagem: 'Pesquisando Unidades Organizacionais',
                  tipo: 'Query',
                  pesquisa: 'getUnidadesOrganizacionais {idUnidadeOrganizacional, descricao}',
                  objRetorno: 'getUnidadesOrganizacionais'
                }
                }
              />

            </Grid>

            <Grid item xs={12} md={6} sx={{ pl: { md: 1 } }}>

              <SelectMultiplo
                fieldsRetornoObjeto={['idUsuario', 'nome']}
                dados={rsPesquisa}
                field='rsUsuarios'
                fieldIdSelect='idUsuario'
                fieldSelect='nome'
                label='Usuários'
                setState={setRsPesquisa}
                pesquisaInicial={{
                  mensagem: 'Pesquisando Usuários',
                  tipo: 'Query',
                  pesquisa: 'getUsuarios {idUsuario, nome}',
                  objRetorno: 'getUsuarios'
                }
                }
              />

            </Grid>

            <Grid item xs={12} textAlign='right' sx={{ mt: 3 }}>
              <Button variant='contained' onClick={() => { btPesquisar() }}>Pesquisar</Button>
            </Grid>

            <Grid item xs={12} sx={{ mt: 3 }}>
              <DataTable dados={rsRelDesempenho} cabecalho={Cabecalho} />
            </Grid>
            <Condicional condicao={rsRelDesempenho.length > 0}>
              <Grid item xs={12} textAlign='right' sx={{ mt: 3 }}>
                <Button variant='contained' onClick={() => { btDownload() }}>Download</Button>
              </Grid>
            </Condicional>

          </Grid>

        </Paper>

      </Container >

      <ExibirJSONDev oque={['rsPesquisa', rsPesquisa, 'rsRelDesempenho', rsRelDesempenho]} />

    </>
  )

}